import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'

import { selectIsStaticSalesDemo } from 'containers/App/selectors'

import AccountSetup from 'components/pages/navigation/accountSetup'

import actions from './actions'
import {
  selectData,
  selectDoToCount,
  selectError,
  selectLoader,
  selectStepLoader,
} from './selectors'

const mapDispatchToProps = (dispatch) => bindActionCreators(actions, dispatch)
const mapStateToProps = (state) => ({
  data: selectData(state),
  loader: selectLoader(state),
  error: selectError(state),

  todoCount: selectDoToCount(state),

  stepLoader: selectStepLoader(state),

  isStaticSalesDemo: selectIsStaticSalesDemo(state),
})

const render = connect(mapStateToProps, mapDispatchToProps)(AccountSetup)

export default withRouter(render)
